/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ResetAccessCredentials$Params {
  clientID: number;
  id: number;
}

export function ResetAccessCredentials(http: HttpClient, rootUrl: string, params: ResetAccessCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, ResetAccessCredentials.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

ResetAccessCredentials.PATH = '/api/ClientUsers/{clientID}/ResetAccessCredentials/{id}';
